import { http } from './utils/http';

export function getInfo() {
    return http.get('/api/mvb/safe');
}

export function reveal(code) {
    return http.get(`/api/mvb/safe/code/${code}`);
}

export function showPrize(token) {
    return http.get(`/api/mvb/safe/prize/${token}`);
}
